import { render, staticRenderFns } from "./EcardTemplateEdit.vue?vue&type=template&id=c4987a90&"
import script from "./EcardTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./EcardTemplateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports